<section class="record">
    <span>
        <span class="details-toggle"></span>
        <span c-activity-log-blurb activity="activity"></span>
        {{header}}
        <span class="tag">{{tag | cDate}}</span>
    </span>
</section>
